import Backbone from 'backbone';

export default Backbone.Model.extend({
  default: {
    control_name: '',
    display_name: '',
    control_id: null,
    icon_url: '',
    group: null,
    status: 0,
    isDeprecated: 0,
    isFromDesigner: 1,
    isOnMarketplace: 0
  }
});
